import React, { FC } from 'react';
import styled from 'styled-components';
import { CaptionContainer, ParentContainer, SwitchGroupContainer } from './switchGroupContainer';
import { SwitchGroupLabel } from './switchGroupLabel';
import { SwitchGroupLeftWrapper } from './switchGroupLeftWrapper';
import { SwitchGroupLink } from './switchGroupLink';
import { SwitchGroupRightWrapper } from './switchGroupRightWrapper';
import { HelpIcon, HelpIconContainer } from '../helpIconContainer';
import { ZSwitchVariant, ZSwitch } from '../zswitch';
import { SwitchGroupCaption, SwitchGroupLabelContainer } from './switchGroupLabelContainer';

const StyledHelpIconContainer = styled(HelpIconContainer)`
    vertical-align: middle;
`;

const BadgeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    > *:first-child {
        margin-left: 24px;
    }
`;

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string | React.ReactElement<any>;
    caption?: React.ReactNode;
    readMore?: { label: string; link: string };
    className?: string;
    helpToolTip?: React.ReactElement<any> | string | null;
    helpTooltipPosition?: 'left' | 'top' | 'right' | 'bottom';
    iconTooltip?: React.ReactNode;
    disabled?: boolean;
    variant?: ZSwitchVariant;
    badges?: React.ReactNode[];
}

export const _switchGroup: FC<SwitchProps> = ({
    checked,
    onChange,
    readMore,
    className,
    label,
    caption,
    helpToolTip,
    helpTooltipPosition,
    iconTooltip,
    disabled,
    variant,
    badges
}) => {
    return (
        <SwitchGroupContainer className={className}>
            <ParentContainer>
                <SwitchGroupLeftWrapper>
                    <ZSwitch checked={checked} onChange={onChange} disabled={disabled} variant={variant ?? 'default'} />
                </SwitchGroupLeftWrapper>
                <SwitchGroupRightWrapper>
                    <SwitchGroupLabelContainer>{label && <SwitchGroupLabel>{label}</SwitchGroupLabel>}</SwitchGroupLabelContainer>
                    {readMore?.label && (
                        <SwitchGroupLink target={'_blank'} href={readMore.link}>
                            {readMore.label}
                        </SwitchGroupLink>
                    )}
                </SwitchGroupRightWrapper>
                {helpToolTip && (
                    <StyledHelpIconContainer tooltip={helpToolTip} position={helpTooltipPosition}>
                        {iconTooltip || <HelpIcon />}
                    </StyledHelpIconContainer>
                )}
                {badges && badges.length > 0 && (
                    <BadgeContainer>
                        {badges.map((badge, index) => (
                            <React.Fragment key={index}>{badge}</React.Fragment>
                        ))}
                    </BadgeContainer>
                )}
            </ParentContainer>
            {caption && (
                <CaptionContainer>
                    <SwitchGroupCaption>{caption}</SwitchGroupCaption>
                </CaptionContainer>
            )}
        </SwitchGroupContainer>
    );
};

export const SwitchGroup = styled(_switchGroup)``;
export * from './subSwitchGroupContent';
